import React from "react";
import AdminLayout from "../layouts/AdminLayout";
import ManageRequestView from "../components/manage-request/ManageRequestView";

const ManageRequest = () => {
  return (
    <AdminLayout>
      <ManageRequestView />
    </AdminLayout>
  );
};

export default ManageRequest;